import React from 'react';
import { IconContainer } from './IconContainer';

const CircleIcon = () => {
    return (
        <IconContainer ariaLabel="circle">
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="6" r="4" fill="#FCFCFC" stroke="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { CircleIcon };